import { DetailedHTMLProps, HTMLAttributes } from "react";

export default function UnorderedList(props: DetailedHTMLProps<HTMLAttributes<HTMLUListElement>, HTMLUListElement>) {
  return <ul {...props}>{props.children}</ul>;
}
